export default __webpack_public_path__ + "static/media/Band of the Celestial Bureaucracy.6060a9cd.jpg";